export default __webpack_public_path__ + "static/media/project2.d3ebb7b1.png";